import config from '../utils/ApiUrl';
import { getCookie, handleSessionExpire } from './session';

const API_URL = config.API_URL;

const getAdminFieldsService = {
  getAdminFields: async () => {
    const sessionToken = getCookie();
    if (!sessionToken) return handleSessionExpire();

    const response = await fetch(`${API_URL}/adminFields`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${sessionToken}`,
      },
    });
    const data = await response.json();
    return data.session ? handleSessionExpire() : data.fields;
  },

  updateAdminField: async (id, updatedField) => {
    const sessionToken = getCookie();
    if (!sessionToken) return handleSessionExpire();

    const response = await fetch(`${API_URL}/adminFields/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionToken}`,
      },
      body: JSON.stringify(updatedField),
    });
    const data = await response.json();
    return data.session ? handleSessionExpire() : data;
  },

  deleteAdminField: async (id, position) => {
    const sessionToken = getCookie();
    if (!sessionToken) return handleSessionExpire();

    await fetch(`${API_URL}/adminFields/${id}/${position}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${sessionToken}`,
      },
    });
  },

  addAdminField: async (newField) => {
    const sessionToken = getCookie();
    if (!sessionToken) return handleSessionExpire();

    const response = await fetch(`${API_URL}/adminFields`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionToken}`,
      },
      body: JSON.stringify(newField),
    });
    const data = await response.json();
    return data.session ? handleSessionExpire() : data;
  },
};

export default getAdminFieldsService;
